import type { StringObject } from './common';
import type { ConnectyCubeConfig } from './config';
import type { ConnectyCubeAuth } from './auth';

export enum ProxyMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
  HEAD = 'HEAD',
}
export enum ProxyType {
  JSON = 'json',
  TEXT = 'text',
}

export type ProxyRequestObject = {
  method: string;
  body?: BodyInit;
  headers?: StringObject;
  signal?: AbortSignal;
  timeout?: number;
};

export type ProxyResponseBody = unknown;

export type FetchResponse = {
  ok: boolean;
  status?: number;
  url?: string;
  text(): Promise<string>;
  json(): Promise<unknown>;
};

export namespace ConnectyCubeProxy {
  export type Params = {
    url: string;
    type?: ProxyMethod;
    data?: unknown;
    contentType?: boolean;
    dataType?: ProxyType;
    useArrayQuery?: boolean;
    fileToCustomObject?: boolean;
    authKey?: string;
    abort_id?: string | number;
  };
  export type AbortControllersMap = {
    [key: string | number]: {
      controllers: AbortController[];
      doneRequestsCount?: number;
    };
  };
  export type SDKInstance = {
    config: ConnectyCubeConfig.Object;
    session: Partial<ConnectyCubeAuth.Session> | null;
  };
  export type ErrorObject = {
    code?: number;
    info?: { errors?: { base?: string[] } };
  };
}
